var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallLocationPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0c-3.87 0-7 3.13-7 7 0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 010-5 2.5 2.5 0 010 5z",
    fill: "#036"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAxNSAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuNSAwQzMuNjMgMCAwLjUgMy4xMyAwLjUgN0MwLjUgMTIuMjUgNy41IDIwIDcuNSAyMEM3LjUgMjAgMTQuNSAxMi4yNSAxNC41IDdDMTQuNSAzLjEzIDExLjM3IDAgNy41IDBaTTcuNSA5LjVDNi4xMiA5LjUgNSA4LjM4IDUgN0M1IDUuNjIgNi4xMiA0LjUgNy41IDQuNUM4Ljg4IDQuNSAxMCA1LjYyIDEwIDdDMTAgOC4zOCA4Ljg4IDkuNSA3LjUgOS41WiIgZmlsbD0iIzAwMzM2NiIvPgo8L3N2Zz4K";
export { SvgSmallLocationPin as ReactComponent };